import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from "../../../../../utils/cn";
import { jsx as _jsx } from "react/jsx-runtime";
const SelectAll = _ref => {
  let {
    hide = false,
    onSelectAll
  } = _ref;
  const [hidden, setHide] = useState(hide);
  useEffect(() => {
    if (hidden) {
      setHide(true);
    }
  });
  const selectAllClass = () => cn({
    'px-2.5 py-2 text-sm text-action-blue font-medium-font': true,
    hidden: hide
  });
  if (hidden) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "select-all",
    className: selectAllClass(),
    children: /*#__PURE__*/_jsx("a", {
      onClick: onSelectAll,
      role: "button",
      tabIndex: 0,
      children: "Select All"
    })
  });
};
SelectAll.propTypes = {
  hide: PropTypes.bool,
  onSelectAll: PropTypes.func.isRequired
};
export default SelectAll;
//# sourceMappingURL=SelectAll.js.map